<template>
  <el-tooltip class="resend-tooltip" :content="errorMessage" placement="bottom">
    <i
      :class="{ '!hidden': !isVisible, '!inline': isVisible }"
      :disabled="buttonDisabled"
      class="el-icon-warning error-icon"
      @click="resendMessage()"
    />
  </el-tooltip>
</template>

<script>
import { FAILED_MESSAGE_ERROR_TEXT } from "@/utils";
export default {
  props: {
    isVisible: Boolean,
    resendMessage: Function,
    isDisabled: Boolean,
    errorMessage: String,
  },
  computed: {
    buttonDisabled() {
      return this.isDisabled || this.errorMessage !== FAILED_MESSAGE_ERROR_TEXT;
    },
  },
};
</script>

<style scoped>
.resend-tooltip {
  padding: 0;
  border: none;
}

.error-icon {
  color: #ff392e;
  background-color: white;
  border-radius: 50%;
  cursor: pointer;
  margin: 0 5px 10px -10px;
}

.error-icon::before {
  font-size: 18px;
}
</style>
